import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SlaEscalationsService } from '../tokens/sla-escalations.token';
import { SlaEscalation } from '../models/sla-escalation.model';
import { API_PATHS } from '../config/api-paths';

/**
 * REST-backed implementation of `SlaEscalationsService` (EM-1855).
 *
 * GET /services/embedded/api/master-admin/sla-escalations → SlaEscalation[] (ROLE_MASTER_ADMIN).
 *
 * Rule 10 — no mock fallback. Errors propagate; the page surfaces them per Rule 09.
 */
@Injectable()
export class SlaEscalationsRestService implements SlaEscalationsService {
  private readonly http = inject(HttpClient);

  listActive(): Observable<SlaEscalation[]> {
    return this.http.get<SlaEscalation[]>(`${API_PATHS.EMBEDDED_API_BASE}/master-admin/sla-escalations`);
  }
}
